<template>
<nav>
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{ name: 'partners' }">Partners</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'create_partner' }">New Partner</router-link></li>
    </li>
    <li v-if="partnerId">
      <router-link :to="{ name: 'edit_partner', params: {
        partnerId: partnerId
      }}">Edit Partner</router-link>
    </li>
    <li v-if="partnerId">
      <router-link :to="{ name: 'partner_apps', params: {
        partnerId: partnerId
      }}">Partner Apps</router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['partnerId']
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerNav.vue